/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import { all } from 'redux-saga/effects';
import { userMailSagas } from './components/AccountUserApp/AccountUserMail/sagas';
import { userProfileSagas } from './components/AccountUserApp/AccountUserProfile/sagas';
import { accountUserSettingsSagas } from './components/AccountUserApp/AccountUserSettings/sagas';
import { userSearchSagas } from './components/AccountUserApp/IncrementalUserSearch/sagas';
import { userFeedbackSagas } from './components/AccountUserApp/UserFeedback/sagas';
import { bettingSagas } from './components/Betting/sagas';
import { notificationStatusSagas } from './components/BettingApp/BettingProfile/NotificationStatus/sagas';
import { bettingProfileSagas } from './components/BettingApp/BettingProfile/sagas';
import { bettingViewSagas } from './components/BettingApp/BettingView/sagas';
import { hsdSagas } from './components/BettingApp/HighscoreStrategyDescriptorScreen/sagas';
import { tournamentArchiveSagas } from './components/BettingApp/TournamentArchive/sagas';
import { hsdEditSagas } from './components/BettingApp/UserGroupHighscoreDescriptorDialog/sagas';
import { blogSagas } from './components/BloggingApp/sagas';
import { portletSagas } from './components/common/RssPortlet/sagas';
import { groupInternalHighscoreSagas } from './components/GroupInternalHighscores/sagas';
import { jobManagementSagas } from './components/JobManagement/sagas';
import { myPlaylistSagas } from './components/Playlist/MyPlayList/sagas';
import { albumEditSagas } from './components/PlaylistAdminApp/AlbumEdit/sagas';
import { albumSagas } from './components/PlaylistAdminApp/AlbumList/sagas';
import { playlistMaintenanceSagas } from './components/PlaylistAdminApp/Maintenance/sagas';
import { playlistSearchSagas } from './components/PlaylistAdminApp/PlaylistSearch/sagas';
import { playlistStatisticsSaga } from './components/PlaylistAdminApp/PlaylistStatistics/sagas';
import { songEditSagas } from './components/PlaylistAdminApp/SongEdit/sagas';
import { songSagas } from './components/PlaylistAdminApp/SongList/sagas';
import { portalSagas } from './components/RadioEins/Portal/sagas';
import { radioEinsSagas } from './components/RadioEins/sagas';
import { rankingSagas } from './components/RankingComponent/sagas';
import { cacheSagas } from './components/SysAdminApp/CacheStatisticsComponent/sagas';
import { eventHandlerConfigSagas } from './components/SysAdminApp/EventHandlerConfig/sagas';
import { sqlStatisticSagas } from './components/SysAdminApp/SQLStatisticsComponent/sagas';
import { sagaUseCaseLogs } from './components/SysAdminApp/UseCaseLogs/sagas';
import { webUsageSagas } from './components/SysAdminApp/WebUsage/sagas';
import { htmlIncludeSagas } from './components/System/HtmlInclude/sagas';
import { systemSagas } from './components/System/sagas';
import { tournamentSelectionSagas } from './components/TournamentSelectionComponent/sagas';
import groupHighscoreSaga from './components/UserGroupHighscores/sagas';
import { userGroupListSagas } from './components/UserGroupList/sagas';
import { userListSagas } from './components/UserList/sagas';
import { userViewSagas } from './components/UserView/sagas';
import { userGroupSagas } from './screens/UserGroupController/saga';
import { ugtsSagas } from './screens/UserGroupController/UserGroupTournamentSubscriptions/sagas';
import { userAdminSagas } from './components/SysAdminApp/UserAdmin/sagas';
import { matchStatisticSagas} from './components/BettingApp/MatchStatistic/sagas';
import { actionTokenSagas } from './components/System/ActionToken/sagas';
import { roundWinnersSagas } from './components/BettingApp/RoundWinners/sagas';
import { groupInternalHighscoreForwarderSagas } from './components/GroupInternaltHighscoresForwarder/sagas';
import { myGroupHighscoreSagas } from './components/BettingApp/MyGroupHighscores/sagas';
import { userLinkSagas } from './links/UserLink/sagas';
import { teamChatSagas } from './components/TeamChat/sagas';
import { systemPropertiesSagas } from './screens/SysAdmin/SystemProperties/saga';

export default function* rootSaga() {
    yield all([
        groupHighscoreSaga(),
        groupInternalHighscoreSagas(),
        albumSagas(),
        systemSagas(),
        songSagas(),
        userGroupListSagas(),
        userListSagas(),
        bettingSagas(),
        playlistStatisticsSaga(),
        playlistSearchSagas(),
        songEditSagas(),
        albumEditSagas(),
        htmlIncludeSagas(),
        playlistMaintenanceSagas(),
        jobManagementSagas(),
        userGroupSagas(),
        tournamentSelectionSagas(),
        bettingProfileSagas(),
        rankingSagas(),
        sqlStatisticSagas(),
        userProfileSagas(),
        accountUserSettingsSagas(),
        userViewSagas(),
        myPlaylistSagas(),
        bettingViewSagas(),
        hsdSagas(),
        hsdEditSagas(),
        cacheSagas(),
        notificationStatusSagas(),
        userMailSagas(),
        userSearchSagas(),
        userFeedbackSagas(),
        ugtsSagas(),
        portletSagas(),
        radioEinsSagas(),
        portalSagas(),
        blogSagas(),
        tournamentArchiveSagas(),
        webUsageSagas(),
        sagaUseCaseLogs(),
        eventHandlerConfigSagas(),
        userAdminSagas(),
        matchStatisticSagas(),
        actionTokenSagas(),
        roundWinnersSagas(),
        groupInternalHighscoreForwarderSagas(),
        myGroupHighscoreSagas(),
        userLinkSagas(),
        teamChatSagas(),
        systemPropertiesSagas()
    ]);
}
